import type { ChangeTemplatePreviewRow } from '../services/orders.service';

export interface LegChangeGroup {
  label: string;
  kind: 'replaced' | 'kept';
  pros: string[];
}

// Change Template for All's review: eligible pros grouped by what the apply will do
// to their legs (bugfix/#34227), in first-seen order. Keyed on the server's
// location-free `group`, so pros with different pickups but the same outcome land
// together. Pros whose stops already match the template are left out.
export const groupLegChanges = (rows: ChangeTemplatePreviewRow[]): LegChangeGroup[] => {
  const groups = new Map<string, LegChangeGroup>();
  for (const r of rows) {
    if (!r.eligible || !r.legChange) continue;
    const key = r.legChange.group;
    const g = groups.get(key) ?? { label: key, kind: r.legChange.kind, pros: [] };
    g.pros.push(String(r.pronumber));
    groups.set(key, g);
  }
  return [...groups.values()];
};
